export const BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS = [
    '[data-benefits-onboarding-anchor="products"]',
    '[data-testid^="benefit-card-configure-"]',
    '[data-benefits-onboarding-anchor="new-recharge"]',
    '[data-benefits-onboarding-anchor="recharges"]',
    '[data-testid="quick-action-contracted-benefits"]',
    '[data-testid="quick-action-beneficiaries"]',
    '[data-testid="quick-action-tracking-cards"]',
    '[data-testid="quick-action-network"]',
];
export const BENEFITS_ONBOARDING_TOUR_STEP_COUNT = BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS.length;
export const BENEFITS_ONBOARDING_TOUR_PANEL_DEFAULT_MAX_WIDTH_PX = 297;
export const BENEFITS_ONBOARDING_TOUR_STEP_PANEL_MAX_WIDTH_PX = [
    297, 297, 297, 297, 320, 297, 297, 297,
];
export const BENEFITS_ONBOARDING_TOUR_STEP_PANEL_HORIZONTAL = [
    'start',
    'start',
    'end',
    'start',
    'start',
    'start',
    'start',
    'start',
];
export const BENEFITS_ONBOARDING_TOUR_STEP_PANEL_PLACEMENT = [
    'stack',
    'stack',
    'leading',
    'trailing',
    'leading',
    'leading',
    'leading',
    'leading',
];
export const BENEFITS_ONBOARDING_TOUR_STEP_LEADING_VERTICAL = [
    'center',
    'center',
    'start',
    'center',
    'start',
    'start',
    'start',
    'start',
];
export const BENEFITS_ONBOARDING_TOUR_STEP_ARROW_X = [
    'panel-start',
    'hole-center',
    'hole-center',
    'hole-center',
    'hole-center',
    'hole-center',
    'hole-center',
    'hole-center',
];
const BENEFITS_ONBOARDING_PRODUCTS_ANCHOR = '[data-benefits-onboarding-anchor="products"]';
const BENEFITS_ONBOARDING_FIRST_CARD = '[data-testid^="active-card-"],[data-testid^="inactive-card-"]';
export function resolveFirstProductConfigureOnboardingTarget() {
    const products = document.querySelector(BENEFITS_ONBOARDING_PRODUCTS_ANCHOR);
    if (products) {
        const firstCard = products.querySelector(BENEFITS_ONBOARDING_FIRST_CARD);
        if (firstCard) {
            const cta = firstCard.querySelector('[data-benefit-onboarding-configure="cta"]');
            if (cta) {
                return cta;
            }
            const iconBtn = firstCard.querySelector('[data-benefit-onboarding-configure="icon"]');
            if (iconBtn) {
                return iconBtn;
            }
            return firstCard.querySelector('[data-testid^="benefit-card-configure-"]');
        }
    }
    return document.querySelector('[data-testid^="benefit-card-configure-"]');
}
export const LEGACY_BENEFITS_ONBOARDING_TOUR_CONFIG = {
    stepSelectors: BENEFITS_ONBOARDING_TOUR_STEP_SELECTORS,
    stepCount: BENEFITS_ONBOARDING_TOUR_STEP_COUNT,
    translationKeyPrefix: 'benefits.onboarding.tour',
    panelDefaultMaxWidthPx: BENEFITS_ONBOARDING_TOUR_PANEL_DEFAULT_MAX_WIDTH_PX,
    panelMaxWidthPx: BENEFITS_ONBOARDING_TOUR_STEP_PANEL_MAX_WIDTH_PX,
    panelHorizontalAlign: BENEFITS_ONBOARDING_TOUR_STEP_PANEL_HORIZONTAL,
    panelPlacement: BENEFITS_ONBOARDING_TOUR_STEP_PANEL_PLACEMENT,
    leadingVerticalAlign: BENEFITS_ONBOARDING_TOUR_STEP_LEADING_VERTICAL,
    arrowXMode: BENEFITS_ONBOARDING_TOUR_STEP_ARROW_X,
    resolveTargetElementForStep: stepIndex => (stepIndex === 1 ? resolveFirstProductConfigureOnboardingTarget() : null),
};
